const viewports = {
  SMALL: 'SMALL',
  MEDIUM: 'MEDIUM',
  LARGE: 'LARGE',
  X_LARGE: 'X_LARGE',
};

const breakpoints = {
  SMALL: 0,
  MEDIUM: 640,
  LARGE: 1025,
  X_LARGE: 1600,
};

export { breakpoints, viewports };



// WEBPACK FOOTER //
// ./src/constants/breakpoints.js